import React from 'react'
import cob1 from '../../../images/cob1.png'

import cob2 from '../../../images/cob2.png'

import cob3 from '../../../images/cob3.png'

const First_pane = () => {
  return (
    <div>
            
            <div 
                style={{ backgroundImage: `url(${cob1})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                paddingBottom: '50px',
                paddingTop: '100px',
                height: '110vh'
            }}
    
            >
                <div className='uk-container uk-margin-xlarge-top'>
                    <div className='uk-grid'>
                        <div className='uk-width-1-2@s'>
    
                        <h1 className='light uk-text-bold header1' uk-scrollspy="cls: uk-animation-slide-top; repeat: true"></h1>
                        <h5 className='light uk-margin-small-top' uk-scrollspy="cls: uk-animation-slide-bottom; repeat: true">
        </h5>
                        </div>
    
                        <div className='uk-width-1-2@s'>
                            <div>
                                 <h5 className='light'>                                       
    </h5>
                             </div>
                        </div>
                    </div>
    
    
                </div>
               
              
            </div>


            <div className='uk-container'>

              <div className=' uk-margin-large-top uk-text-center'>
                  <div className='uk-width-1-1'>
                    <img src= {cob2} />
                  </div>

                 
              </div>
              



                <div className='uk-text-center uk-margin-xlarge-top' >
                    <img src= {cob3} />
                </div>


                   <div className='uk-grid uk-margin-large-top'>
                    <div className='uk-width-1-2@s'>
                        <h4 className='uk-text-bold'> FEATURES</h4>
                      <ol class="styled-list">
                        <li>Contemporary Design</li>
                        <li>4 Bedroom all En-suite</li>
                        <li>Sizeable Lounge + Dinning</li>
                        <li>Sizeable Kitchen + Store</li>
                        <li>Visitor’s Toilet</li>
                        <li>Private Family Lounge</li>
                        <li>Private Backyard</li>
                     </ol>


                     


                    </div>

                    <div className='uk-width-1-2@s'>
                        <div>
                            <h4 className='uk-text-bold'>GET STARTED TODAY WITH FLEXIBLE PAYMENT PLANS</h4>
                             <h5 className='uk-margin-top'>OFF-PLAN: N300M</h5>
                             <h5>DURING CONSTRUCTION: N350M - N380M</h5>
                             <h5>AT COMPLETION: N450</h5>
                        </div>
                    </div>
               </div>


          </div>
    
  
            
        </div>
  )
}

export default First_pane